import api from '../../libs/api'
import { getP } from 'redux-polyglot'

export const STEP_TWO_FETCH_OPTIONS = 'TICKET_NEW/STEP_TWO_FETCH_OPTIONS'

export const fetchStepTwoOptions = () => ({
	type:STEP_TWO_FETCH_OPTIONS,
	payload:{
		 options: [{
            id: 1,
            value : "Issue is happening on all the channels",
            nextUrl: "support/tickets/reply"
          },
          {
            id: 2,
            value : "Issue is specific to a channel or channels",
            nextUrl: "support/tickets/step/three"
          }, {
            id: 3,
            value : "Issue does not apply on channels",
            nextUrl: "support/tickets/reply"
          }]
	}
})

export const fetchStepTwoOptionsRequest = () => (dispatch) => {
	return Promise.all([
    	dispatch(fetchStepTwoOptions())
  		])
	
}

export const STEP_TWO_FOCUS_POSITION = 'TICKET_NEW/STEP_TWO_FOCUS_POSITION'
export const STEP_TWO_FOCUS = 'TICKET_NEW/STEP_TWO_FOCUS'
export const STEP_TWO_SELECT = 'TICKET_NEW/STEP_TWO_SELECT'

export const focusPositionStepTwoRequest = (position) => ({
	type:STEP_TWO_FOCUS_POSITION,
	payload:{
		position
	}
})

export const focusTypePositionStepTwo = pos => (dispatch, getState) => {
	    dispatch(focusPositionStepTwoRequest(pos))
}

export const stepTwoSelectRequest = (id) => ({
	type:STEP_TWO_SELECT,
	payload:{
		id
	}
})

export const stepTwoSelect = id => (dispatch, getState) => {
	    dispatch(stepTwoSelectRequest(id))
}


export const focusStepTwoRequest = (id) => ({
	type:STEP_TWO_FOCUS,
	payload:{
		id
	}
})

export const focusTypeStepTwo = id => (dispatch, getState) => {
	    dispatch(focusStepTwoRequest(id))
}
export const DISMISS_ERROR = 'TICKET_NEW/DISMISS_ERROR'
export const dismissError = () => ({
  type: DISMISS_ERROR
})